import React from 'react';

import {
  Box, Table, TagChip, Typography, Link,
} from 'vindi-ds-components';

import tagChipPaymentStatus from '../utils/tag_chip_payment_status';
import EmptyStateCharges from './empty_state';

const columns = [
  {
    label: 'ID',
    align: 'left',
  },
  {
    label: 'Cliente',
    align: 'left',
  },
  {
    label: 'Valor',
    align: 'right',
  },
  {
    label: 'Emissão',
    align: 'left',
  },
  {
    label: 'Vencimento',
    align: 'left',
  },
  {
    label: 'Pagamento',
    align: 'left',
  },
  {
    label: 'Status do pagamento',
    align: 'left',
  },
];

const Customer = ({ customer }) => (
  <Box display='flex' flexDirection='column'>
    <Typography variant='body2'>{customer.name}</Typography>
    <Typography variant='caption' color='textSecondary'>{customer.id}</Typography>
  </Box>
);

const Value = ({ value, paymentMethod }) => (
  <Box display='flex' flexDirection='column' alignItems='flex-end'>
    <Typography variant='body2'>{value}</Typography>
    <Typography variant='caption' color='textSecondary'>{paymentMethod}</Typography>
  </Box>
);

const TableCharges = ({ charges }) => (
  <Table.Container emptyState={<EmptyStateCharges />}>
    <Table.Head columns={columns} />
    <Table.Body>
      {charges.map((charge) => (
        <Table.Row key={charge.id}>
          <Table.Cell>
            <Link href='/'>
              <Typography variant='body2'>
                {charge.id}
              </Typography>
            </Link>
          </Table.Cell>

          <Table.Cell>
            <Customer customer={charge.customer} />
          </Table.Cell>

          <Table.Cell align='right'>
            <Value value={charge.amount} paymentMethod={charge.payment_method_name} />
          </Table.Cell>

          <Table.Cell>
            {charge.created_at}
          </Table.Cell>

          <Table.Cell>
            {charge.due_at}
          </Table.Cell>

          <Table.Cell>
            {charge.paid_at}
          </Table.Cell>

          <Table.Cell>
            <TagChip label={charge.status} kind={tagChipPaymentStatus(charge.status)} />
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table.Container>
);

export default TableCharges;
